<!-- Toolbar -->
<mat-toolbar>
  <div class="toolbar general-structure">

    @if (!isMobile) {
    <address>
      <a class="email" href="mailto:cositalnetwork@cosital.es">cositalnetwork&#64;cosital.es</a>
      <div class="social">
        <a href="https://twitter.com/Cositalnetwork" title="X" target="_blank">
          <span class="icon-x"></span>
        </a>
        <a href="https://www.facebook.com/pages/Cositalnetwork/371811616242353?ref=stream" title="facebook"
          target="_blank">
          <span class="icon-facebook"></span>
        </a>
        <a href="https://t.me/joinchat/AAAAAFZDu7pxB2Zxtq3B9w" title="telegram" target="_blank">
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
            stroke-linecap="round" stroke-linejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
          </svg>
        </a>
      </div>
    </address>
    } @else {
    <button mat-icon-button (click)="openMenu()">
      <mat-icon>menu</mat-icon>
    </button>
    }

    <div class="toolbar-content">

      <div class="search-block">

        <!-- Buscador -->
        <div *ngIf="!isMobile" class="header-toolbar-search-container"
          [class.hidden-header]="scrollOffset > HEADER_HEIGHT">
          <form [formGroup]="form" (submit)="resultSearch=null; searchAdvanced();">
            <mat-form-field class="search-input" floatLabel="never">
              <input formControlName="searchText" type="text" matInput placeholder="{{'general.search' | translate}}"
                #searchText>
              <mat-icon [class.show]="searchText.value.length>0" matSuffix class="close-search-button"
                (click)="searchText.value=''; resultSearch=null;">close</mat-icon>
            </mat-form-field>
            <button mat-icon-button (click)="resultSearch=null; searchAdvanced()"
              [disabled]="searchText.value.length<MIN_LENGTH_TO_SEARCH">
              <mat-icon svgIcon="search"></mat-icon>
            </button>
          </form>
        </div>

        <!-- Resultado de la búsqueda -->
        <ng-container *ngIf="resultSearch && resultSearch.length > 0">
          <div class="search-results search-results-desktop">
            <div class="result" *ngFor="let result of resultSearch" [routerLink]="result.url">
              <img *ngIf="result.image" [src]="result.image" [alt]="result.title"
                (error)="image.src='../../../../assets/img/default.webp'" #image loading="lazy">
              <div class="info">
                <p *ngIf="result.category" class="result-category">{{result.category}}</p>
                <p *ngIf="result.location" class="result-location">{{result.location}}</p>
                <p class="result-title">{{result.title}}</p>
                <time>{{result.createdAt|date:'mediumDate'}}</time>
                <div *ngIf="result.description" class="result-description num-lines-2"
                  [innerHTML]="result.description|truncate:150|safeHtml"></div>
                <div *ngIf="result.price" class="price">{{result.price | currency:'EUR':'symbol':'1.2-2'}}</div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <!-- Logged -->
      <div *ngIf="authService.isLoggedIn() && authService.user" class="user-info" [matMenuTriggerFor]="userMenu">
        <mat-icon svgIcon="user"></mat-icon>
        <span class="user-name-desktop">{{ authService.user.name }} </span>
        <mat-icon svgIcon="chevron-down"></mat-icon>
        <mat-menu #userMenu="matMenu" class="user-menu" xPosition="before" yPosition="below" overlapTrigger="false">
          <div class="user-header">
            <div class="name">{{ authService.user.name }}</div>
          </div>

          <a mat-menu-item routerLink="/usuarios/editar" title="{{'core.menuPrivate.editUser' | translate}}">
            <mat-icon>edit</mat-icon> {{'core.menuPrivate.editUser' | translate}}
          </a>

          <a mat-menu-item routerLink="/usuarios/lista-direcciones"
            title="{{'core.menuPrivate.addresses' | translate}}">
            <mat-icon>euro_symbol</mat-icon> {{'core.menuPrivate.addresses' | translate}}
          </a>

          <a mat-menu-item routerLink="/usuarios/lista-suscripciones"
            title="{{'core.menuPrivate.subscriptions' | translate}}">
            <mat-icon>loyalty</mat-icon> {{'core.menuPrivate.subscriptions' | translate}}
          </a>

          <a mat-menu-item routerLink="/usuarios/pedidos" title="{{'core.menuPrivate.purchases' | translate}}">
            <mat-icon>local_mall</mat-icon> {{'core.menuPrivate.purchases' | translate}}
          </a>

          <a mat-menu-item routerLink="/usuarios/renovaciones" title="{{'core.menuPrivate.renovations' | translate}}">
            <mat-icon>sync</mat-icon> {{'core.menuPrivate.renovations' | translate}}
          </a>

          <a mat-menu-item routerLink="/usuarios/cambio-password" title="{{'core.menuPrivate.changePass' | translate}}">
            <mat-icon>lock</mat-icon> {{'core.menuPrivate.changePass' | translate}}
          </a>

          <div class="divider"></div>
          <button mat-menu-item class="user-menu-action" (click)="authService.logout()">
            <mat-icon>exit_to_app</mat-icon> {{'core.menuPrivate.signout' | translate}}
          </button>

        </mat-menu>
      </div>

      <!-- Login -->
      @if (!authService.isLoggedIn() || !authService.user) {
      <button mat-flat-button class="user-login" (click)="signinService.openDialog()">
        <div class="button-inner">
          <mat-icon svgIcon="user"></mat-icon>
          <span>{{'core.signin.login' | translate}}</span>
        </div>
      </button>
      }

      <!-- Subscriber -->
      @if (!authService.isLoggedIn() || !authService.user) {
      <a mat-flat-button routerLink="/informacion/suscripciones" [title]="'core.signin.becomeSubscriber' | translate"
        color="accent" class="subscriber-button">
        <span class="subscriber-label-desktop">{{'core.signin.becomeSubscriber' | translate}}</span>
        <span class="subscriber-label-mobile">{{'core.signin.becomeSubscriberXS' | translate}}</span>
      </a>
      }
    </div>

  </div>
</mat-toolbar>

<!-- Header -->

<header class="header">
  <div class="header-content general-structure">
    <div class="logo-container">
      <a routerLink="/home" title="home">
        <img loading="lazy" src="./../../../../assets/img/logo_cositalnetwork_15_aniversario.webp" class="logo">
      </a>
    </div>
    <div class="header-menu">
      <web-menu-header *ngIf="showTemplate" class="header-menu-desktop"></web-menu-header>
    </div>
  </div>
</header>
